import React from "react";
import VoidTickets from "../modules/VoidTickets/VoidTickets";

export default function () {
    return <VoidTickets/>
}